import { ReactElement } from 'react';
import { PaddingProps } from 'styled-system';

import { ThemeType } from 'src/packages/theme';
import { TooltipProps } from 'src/packages/core';

export type FieldAlignment = 'left' | 'center' | 'right';

type CellRendererType = (item: any) => ReactElement;

export enum SortOrderEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export interface TableColumn {
  key?: string;
  label?: string | ReactElement;
  alignment?: FieldAlignment;
  width?: string;
  minWidth?: string;
  cellRenderer?: string | CellRendererType;
  sortable?: boolean;
  sortFunction?: (arr: any[], order: SortOrderEnum) => void;
  tooltip?: TooltipProps;
}

export interface TableProps<T> extends PaddingProps {
  columns?: TableColumn[];
  data: T[];
  highlightRowsOnHover?: boolean;
  hasPagination?: boolean;
  previousDisabled?: boolean;
  onPreviousClick?: () => void;
  nextDisabled?: boolean;
  onNextClick?: () => void;
  activePage?: number;
  totalPages?: number;
  onPageNumClick?: (page: number) => void;
  firstColumnStickyOnMobile?: boolean;
  lastColumnStickyOnMobile?: boolean;
  isLoading?: boolean;
  rowClickHandler?: (item: T) => void;
  theme?: ThemeType;
  borderRadius?: string;
}
